namespace TabAurous.Retail {
    export namespace POSApprovalSelectItemsService {
        export const baseUrl = 'Retail/POSApprovalSelectItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSApprovalItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/POSApprovalSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSApprovalSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
